import { RespondentType } from '../models/questions';
import { isApplePayAvailableAsPaymentMethod as isApplePayAvailableAsPaymentMethodFromOrder } from '../selectors/order';
import { CheckoutState } from '../state';
import { isApplePaySupported } from '../utils/applePay';
import { isEventbriteTLDInDevOrQAEnv, isIosApp } from '../utils/browser';
import { ENABLE_APPLE_PAY } from '../utils/splitio';
import { shouldShowEventCapacityWaitlistPage } from '../utils/waitlist';
import { isEventbriteTLD } from './app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    getSurveyType,
    hasSpecialInstructions,
} from './event';
import {
    hasRequiredCannedQuestions,
    hasRequiredCustomQuestions,
    isApplePayAvailableAsPaymentMethod,
} from './expressCheckout';
import { isSplitTreatmentEnabled } from './splitio';

export const isWaitlistEnabled = (state: CheckoutState) => {
    const {
        app: { waitlistCode },
        event,
        tickets: { ticketsById },
    } = state;

    return shouldShowEventCapacityWaitlistPage(
        event,
        ticketsById,
        waitlistCode,
    );
};

export const isTLDWithApplePayEnabled = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv() || isIosApp(state);

export const isApplePayInCheckoutStepEnabled = (state: CheckoutState) =>
    isApplePayAvailableAsPaymentMethodFromOrder(state) &&
    isTLDWithApplePayEnabled(state) &&
    isSplitTreatmentEnabled(state, ENABLE_APPLE_PAY) &&
    isApplePaySupported();

export const getCanMakePaymentsWithActiveCard = (state: CheckoutState) =>
    state.applepay?.canMakePaymentsWithActiveCard;

export const isApplePaySortedAndPreselected = (state: CheckoutState) =>
    !!getCanMakePaymentsWithActiveCard(state);

export const getApplePayInstance = (state: CheckoutState) =>
    state.applepay?.applepayInstance;

export const hasExpressCheckoutAsyncErrors = (state: CheckoutState) =>
    state.applepay?.hasAsyncErrors;

export const getIsLoadingApplePay = (state: CheckoutState) =>
    state.applepay?.isLoadingApplePay;

export const getIsApplePaySupported = (state: CheckoutState) =>
    state.applepay?.isApplePaySupported;

export const isApplePayInstanceCreated = (state: CheckoutState) =>
    !!getApplePayInstance(state);
export const areSyncExpressCheckoutEligibleRulesMet = (state: CheckoutState) =>
    isTLDWithApplePayEnabled(state) &&
    getIsApplePaySupported(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state) &&
    (getSurveyType(state) === RespondentType.buyer ||
        getSurveyType(state) === RespondentType.direct);

export const areAsyncExpressCheckoutEligibleRulesMet = (state: CheckoutState) =>
    !hasRequiredCannedQuestions(state) &&
    !hasRequiredCustomQuestions(state) &&
    isApplePayAvailableAsPaymentMethod(state) &&
    !hasExpressCheckoutAsyncErrors(state);

export const getApplePay = (state: CheckoutState) => state.applepay;
